// Full updated UsersList component with sorting dropdown (A-Z / Z-A)

import React, { Component } from "react";
import {
  Col,
  Button,
  Row,
  Table
} from "reactstrap";
import { BiTrash } from "react-icons/bi";
import {
  LuBadgeCheck,
  LuChevronLeft,
  LuChevronRight,
  LuDownload,
  LuTrash2,
} from "react-icons/lu";
import Select from "react-select";
import * as url from "./../../../utils/url";
import axios from "../../../axios";
import { connect } from "react-redux";
import OfficeMate from "../../office/OfficeMates/OfficeMate/OfficeMate";
import Loading from "../../../hoc/Loading/Loading";
import { withRouter } from "react-router";
import EmptyTable from "./../../../components/EmptyTable/EmptyTable";
import { toastContainer } from "../../../utils/toast";
import UploadUsersModal from "../../trivia/Components/UploadUsersModal";
import * as actionCreators from "../../../modules/actions";
import UsersTableHeader from "./UsersTableHeading";
import { loadColumnWidths, saveColumnWidths } from "./usersColumns";
import LocalSearchBar from "../../trivia/Components/LocalSearchBar";
import { isMobile } from "../../../utils/deviceInfo";
import "./UsersList.css";



const SORT_OPTIONS = [
  { value: "default", label: "Default" },
  { value: "az", label: "A → Z" },
  { value: "za", label: "Z → A" },
  { value: "newest", label: "Newest" },
  { value: "oldest", label: "Oldest" },
];

class UsersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      officeMates: [],
      allUsers: [], // Store all users for upload modal comparison
      fetchingAllUsers: false, // Prevent multiple API calls
      allUsersLoadFailed: false, // True when the full-user fetch errors (oldUsers then falls back to the partial paginated list)
      searchedTerm: "",
      displayUsers: [],
      pageNum: 1,
      pageLimit: 20,
      totalUsers: 0,
      searchTotalUsers: 0,
      usersRemove: [],
      matchedKeys: [],
      columnNames:[],
      isSearchActive: false,
      isSearching: false,
      sortMode: "default",
      sortOrder:'',
      selectedSortOption: SORT_OPTIONS[0],
      loading:false,
      columnWidths: loadColumnWidths(props.user._id), // null until a column is dragged; then the CSS widths are overridden
    };
  }

  componentDidMount() {
    this.getOfficeMates(this.props.type);
    this.getOrgUserMetaData();
    document.documentElement.classList.add("allow-page-horizontal-scroll");
    document.body.classList.add("allow-page-horizontal-scroll");
  }

  componentWillUnmount() {
    document.documentElement.classList.remove("allow-page-horizontal-scroll");
    document.body.classList.remove("allow-page-horizontal-scroll");
  }

  getOrgUserMetaData = () => {
    axios
      .get(url.getOrgUserMetaData)
      .then(({ data }) => {
        const meta = data.data.data;
        if (!meta) return;
        this.setState({ matchedKeys: meta.matchedKeys,columnNames:meta.columnNames });
      })
      .catch((error) =>
        console.error("Error fetching org user metadata", error)
      );
  };

  getAllUsers = () => {
    if (this.state.fetchingAllUsers) return; // Prevent multiple calls

    this.setState({ fetchingAllUsers: true, allUsersLoadFailed: false });

    // Fetch all users without pagination for accurate "New" user detection in upload modal
    axios
      .get(url.fetchUsers, {
        params: { pageNum: 1, pageLimit: 10000 }, // Large limit to get all users
      })
      .then((response) => {
        const allUsers = response.data.data || [];
        this.setState({ allUsers, fetchingAllUsers: false });
      })
      .catch((error) => {
        console.error("Error fetching all users", error);
        // Fallback to paginated users if all users fetch fails
        this.setState({ allUsers: this.state.officeMates, fetchingAllUsers: false, allUsersLoadFailed: true });
      });
  };


  downloadOptOutReport = () => {
    this.props.fetchSmsOptOutReport()
      .then((data) => {
        const users = (data && Array.isArray(data.data)) ? data.data : (Array.isArray(data) ? data : []);
        const rows = users;
        const csvLines = ['"Name","Phone Number","Messages Opt-out Date","Surveys/KCs Opt-out Date"'];
        rows.forEach((user) => {
          const firstName = user.firstName || '';
          const lastName = user.lastName || '';
          const fullName = (firstName + ' ' + lastName).trim();
          const name = fullName ? fullName : (user.mobileNumber || '');
          const rawPhone = (user.mobileNumber || '').replace(/\D/g, '');
          let phone = user.mobileNumber || '';
          if (rawPhone.length === 11 && rawPhone[0] === '1') {
            phone = '+1 (' + rawPhone.slice(1, 4) + ') ' + rawPhone.slice(4, 7) + '-' + rawPhone.slice(7);
          } else if (rawPhone.length === 10) {
            phone = '(' + rawPhone.slice(0, 3) + ') ' + rawPhone.slice(3, 6) + '-' + rawPhone.slice(6);
          } else if (rawPhone.length > 0) {
            phone = '+' + rawPhone;
          }
          const smsPrefs = user.smsPrefs || {};
          const categories = (smsPrefs && smsPrefs.categories) || {};
          const messages = (categories && categories.messages) || {};
          const surveys = (categories && categories.surveys) || {};
          const messagesOptedOut = messages.optOut && messages.optOut.status === true;
          const surveysOptedOut = surveys.optOut && surveys.optOut.status === true;
          const messagesDate = (messagesOptedOut && messages.changedAt) ? new Date(messages.changedAt).toLocaleDateString('en-US') : 'N/A';
          const surveysDate = (surveysOptedOut && surveys.changedAt) ? new Date(surveys.changedAt).toLocaleDateString('en-US') : 'N/A';
          const escapedName = '"' + name.replace(/"/g, '""') + '"';
          const escapedPhone = '"' + phone.replace(/"/g, '""') + '"';
          const escapedMessagesDate = '"' + messagesDate + '"';
          const escapedSurveysDate = '"' + surveysDate + '"';
          csvLines.push([escapedName, escapedPhone, escapedMessagesDate, escapedSurveysDate].join(','));
        });
        const csvContent = csvLines.join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        const today = new Date();
        const dateStr = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
        link.setAttribute('download', 'SMS Opt-outs as of ' + dateStr + '.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      })
      .catch((err) => {
        console.error('Error fetching opt-out report', err);
        toastContainer('Could not download opt-out report. Please try again.', 'error');
      });
  };

  // Frontend (opens in NEW TAB; no memory buffering; works with cookie/session auth)
  downloadAllUsers = () => {
    console.log(url.getDownloadLink,'link here')
    this.setState({loading:true})
    axios
      .get(url.getDownloadLink) // this call IS authenticated
      .then((res) => {
        this.setState({loading:false})
        window.open(res.data.url, "_blank", "noopener");
      })
      .catch((err) => console.error("Error getting signed link:", err));
  };
  getOfficeMates = (val, page = 1) => {
    const { pageLimit, sortMode ,sortOrder} = this.state;
    console.log("inside office mated",sortMode,sortOrder)
    axios
      .get(url.fetchUsers, {
        params: { pageNum: page, pageLimit, sort: sortMode,sortOrder },
      })
      .then((response) => {
        const users = response.data.data;
        const total = response.data.meta.totalCount || users.length;
        this.setState({
          officeMates: users,
          displayUsers: users,
          pageNum: page,
          totalUsers: total,
          isSearchActive: false,
          usersRemove: [],
        });
        this.props.getUserCount && this.props.getUserCount(total);
      })
      .catch((error) => console.log(error));
  };

  getSearchResults = (text, page = 1) => {
    const { pageLimit, sortMode, sortOrder } = this.state;
    this.setState({ isSearching: true });
    axios
      .get(url.searchUsersForListing, {
        params: { pageNum: page, pageLimit, searchText: text, sort: sortMode, sortOrder },
      })
      .then((response) => {
        const users = response.data.data;
        const total = response.data.meta.totalCount || users.length;
        this.setState({
          displayUsers: users,
          pageNum: page,
          searchTotalUsers: total,
          isSearchActive: true,
          isSearching: false,
          usersRemove: [],
        });
      })
      .catch((error) => {
        console.log("Search error:", error);
        this.setState({ isSearching: false });
      });
  };

  getSearchResults = (text, page = 1) => {
    const { pageLimit, sortMode, sortOrder } = this.state;
    this.setState({ isSearching: true });
    axios
      .get(url.searchUsersForListing, {
        params: {
          pageNum: page,
          pageLimit,
          searchText: text,
          sort: sortMode,
          sortOrder,
        },
      })
      .then((response) => {
        const users = response.data.data;
        const total = response.data.meta.totalCount || users.length;
        this.setState({
          displayUsers: users,
          pageNum: page,
          searchTotalUsers: total,
          isSearchActive: true,
          isSearching: false,
          usersRemove: [],
        });
      })
      .catch((error) => {
        console.log("Search error:", error);
        this.setState({ isSearching: false });
      });
  };

  // LocalSearchBar owns the input and the debounce; the parent keeps
  // `searchedTerm` so sort and pagination can re-run the same query.
  handleSearch = (value) => {
    const searchText = value.trim();
    this.setState({ searchedTerm: searchText }, () => {
      this.getSearchResults(searchText, 1);
    });
  };

  handleEmailChange = (updatedUser) => {
    this.setState((prevState) => ({
      officeMates: prevState.officeMates.map((user) =>
        user._id === updatedUser._id
          ? { ...user, email: updatedUser.email, isDummyEmail: updatedUser.isDummyEmail }
          : user
      ),
      displayUsers: prevState.displayUsers.map((user) =>
        user._id === updatedUser._id
          ? { ...user, email: updatedUser.email, isDummyEmail: updatedUser.isDummyEmail }
          : user
      ),
    }));
  };

  handleMobileNumberChange = (updatedUser) => {
    this.setState((prevState) => ({
      officeMates: prevState.officeMates.map((user) =>
        user._id === updatedUser._id
          ? { ...user, mobileNumber: updatedUser.mobileNumber }
          : user
      ),
      displayUsers: prevState.displayUsers.map((user) =>
        user._id === updatedUser._id
          ? { ...user, mobileNumber: updatedUser.mobileNumber }
          : user
      ),
    }));
  };


  handleEmployeeIdChange = (updatedUser) => {
    this.setState((prevState) => ({
      officeMates: prevState.officeMates.map((user) =>
        user._id === updatedUser._id
          ? { ...user, employeeId: updatedUser.employeeId }
          : user
      ),
      displayUsers: prevState.displayUsers.map((user) =>
        user._id === updatedUser._id
          ? { ...user, employeeId: updatedUser.employeeId }
          : user
      ),
    }));
  };

  updateSortMode = (mode,order) => {
    this.setState({sortMode: mode,sortOrder:order},() => {
      const { pageNum } = this.state;
        this.getOfficeMates(this.props.type, pageNum);
      
    })
    
  };

  handleColumnResize = (columnWidths) => {
    this.setState({ columnWidths });
  };

  // Saved once per drag, not on every mousemove.
  handleColumnResizeEnd = () => {
    if (this.state.columnWidths) {
      saveColumnWidths(this.props.user._id, this.state.columnWidths);
    }
  };

  handleNameChange = (updatedUser) => {
    const { user: loggedInUser, updateUserProfile } = this.props
    const { firstName, lastName } = updatedUser

    if (updatedUser._id === loggedInUser._id) updateUserProfile({ firstName, lastName });
    this.setState((prevState) => ({
      officeMates: prevState.officeMates.map((user) =>
        user._id === updatedUser._id
          ? { ...user, firstName, lastName }
          : user
      ),
      displayUsers: prevState.displayUsers.map((user) =>
        user._id === updatedUser._id
          ? { ...user, firstName, lastName }
          : user
      ),
    }));
  };

  handleRoleChange = (updatedUser) => {
    const { _id, role, orgAdmin } = updatedUser;
    this.setState((prevState) => ({
      officeMates: prevState.officeMates.map((user) =>
        user._id === _id
          ? { ...user, role: role, orgAdmin: orgAdmin }
          : user
      ),
      displayUsers: prevState.displayUsers.map((user) =>
        user._id === _id
          ? { ...user, role: role, orgAdmin: orgAdmin }
          : user
      ),
    }));
    // Check if the user is changing their own role
    if (_id === this.props.user._id) {
      // Update Redux state for the current user
      const updatedUserProfile = {
        ...this.props.user,
        role: role,
        orgAdmin: orgAdmin
      };
      this.props.updateUserProfile(updatedUserProfile);
    }
  };

  clearSearch = () => {
    this.setState(
      { searchedTerm: "", isSearchActive: false, usersRemove: [], pageNum: 1 },
      () => {
        this.getOfficeMates(this.props.type, 1);
      }
    );
  };

  handleSortChange = (selectedOption) => {
    // Escape/clear hands back null (Select.js:562), which used to throw here.
    const nextOption = selectedOption || SORT_OPTIONS[0];

    let sortMode = "default";
    let sortOrder = "";

    if (nextOption.value === "az") {
      sortMode = "az";
    } else if (nextOption.value === "za") {
      sortMode = "za";
    } else if (nextOption.value === "newest") {
      sortMode = "addedDate";
      sortOrder = "desc";
    } else if (nextOption.value === "oldest") {
      sortMode = "addedDate";
      sortOrder = "asc";
    }

    this.setState({ sortMode, sortOrder, selectedSortOption: nextOption }, () => {
      const { isSearchActive, searchedTerm, pageNum } = this.state;
      if (isSearchActive && searchedTerm) {
        this.getSearchResults(searchedTerm, pageNum);
      } else {
        this.getOfficeMates(this.props.type, pageNum);
      }
    });
  };

  removeMultipleUsers = () => {
    const {
      usersRemove,
      pageLimit,
      pageNum,
      isSearchActive,
      searchedTerm,
      totalUsers,
      loading
    } = this.state;
    axios
      .post(url.deleteMultipleUsers, { users: usersRemove })
      .then(() => {
        toastContainer("Users removed successfully", "success");
        const newTotalPages = Math.ceil((totalUsers - usersRemove.length) / pageLimit);
        const newPage = Math.min(pageNum, newTotalPages) || 1;
        this.setState({ usersRemove: [], pageNum: newPage }, () => {
          if (isSearchActive && searchedTerm) {
            this.getSearchResults(searchedTerm, newPage);
          } else {
            this.getOfficeMates(this.props.type, newPage);
          }
        });
      })
      .catch(() => {
        toastContainer("Error removing users", "error");
      });
  };

  userSelectedForRemove = (id) => {
    const { usersRemove } = this.state;
    const updated = usersRemove.includes(id)
      ? usersRemove.filter((uid) => uid !== id)
      : [...usersRemove, id];
    this.setState({ usersRemove: updated });
  };

  handlePageChange = (newPage) => {
    const { searchedTerm, isSearchActive } = this.state;
    if (isSearchActive && searchedTerm) {
      this.getSearchResults(searchedTerm, newPage);
    } else {
      this.getOfficeMates(this.props.type, newPage);
    }
  };

  renderPagination() {
    const {
      pageNum,
      pageLimit,
      isSearchActive,
      totalUsers,
      searchTotalUsers,
      displayUsers,
    } = this.state;
    const total = isSearchActive ? searchTotalUsers : totalUsers;
    const totalPages = Math.ceil(total / pageLimit);
    if (displayUsers.length === 0) return null;

    const currentPage = pageNum;
    const startPage = Math.max(2, currentPage - 2);
    const endPage = Math.min(totalPages - 1, currentPage + 2);

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button
            className="page-link mx-1"
            onClick={() => this.handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    return (
      <Row className="bwai-users-pagination-bar">
        <Col className="d-flex justify-content-between align-items-center">
          <small className="text-muted mx-3 bwai-users-count">
            Showing <strong>{(pageNum - 1) * pageLimit + 1}</strong> to{" "}
            <strong>{Math.min(pageNum * pageLimit, total)}</strong> of{" "}
            <strong>{total}</strong> results
          </small>
          <nav>
            <ul className="pagination justify-content-center bwai-users-pagination">
              <li className={`page-item ${pageNum === 1 ? "disabled" : ""}`}>
                <button
                  className="page-link mx-1"
                  onClick={() => this.handlePageChange(pageNum - 1)}
                >
                  <LuChevronLeft size={16} strokeWidth={2.5} />
                </button>
              </li>
              <li className={`page-item ${pageNum === 1 ? "active" : ""}`}>
                <button
                  className="page-link mx-1"
                  onClick={() => this.handlePageChange(1)}
                >
                  1
                </button>
              </li>
              {currentPage > 4 && (
                <li className="page-item disabled">
                  <span className="page-link mx-1">…</span>
                </li>
              )}
              {pages}
              {currentPage < totalPages - 3 && (
                <li className="page-item disabled">
                  <span className="page-link mx-1">…</span>
                </li>
              )}
              {totalPages > 1 && (
                <li
                  className={`page-item ${currentPage === totalPages ? "active" : ""
                    }`}
                >
                  <button
                    className="page-link mx-1"
                    onClick={() => this.handlePageChange(totalPages)}
                  >
                    {totalPages}
                  </button>
                </li>
              )}
              <li
                className={`page-item ${pageNum === totalPages ? "disabled" : ""
                  }`}
              >
                <button
                  className="page-link mx-1"
                  onClick={() => this.handlePageChange(pageNum + 1)}
                >
                  <LuChevronRight size={16} strokeWidth={2.5} />
                </button>
              </li>
            </ul>
          </nav>
        </Col>
      </Row>
    );
  }

  render() {
    const {
      displayUsers,
      usersRemove,
      selectedSortOption,
      loading,
      sortMode,
      isSearching,
      allUsers,
      columnWidths,
    } = this.state;
    const { uploadUsersModal, setUploadUsersModal } = this.props;
    // Resizing is desktop-only, so saved widths are never applied on mobile —
    // not to the heading and not to any row layout that renders there.
    const appliedColumnWidths = isMobile ? null : columnWidths;

    // Fetch all users when upload modal opens for accurate "New" user detection
    if (uploadUsersModal && allUsers.length === 0 && !this.state.fetchingAllUsers) {
      this.getAllUsers();
    }

console.log("old matched data:", this.state.matchedKeys)
    return (
      <div>
        {uploadUsersModal && (
          <UploadUsersModal
            open={uploadUsersModal}
            bwai
            onClose={() => {
              setUploadUsersModal(false);
              this.setState({ allUsers: [], fetchingAllUsers: false, allUsersLoadFailed: false }); // Clear allUsers and flag when modal closes
            }}
            uploadSuccess={() => {
              this.getOfficeMates(this.props.type);
              setUploadUsersModal(false);
              this.setState({ allUsers: [], fetchingAllUsers: false, allUsersLoadFailed: false }); // Clear allUsers and flag after successful upload
            }}
            oldUsers={allUsers.length > 0 ? allUsers : this.state.officeMates}
            loadingOldUsers={this.state.fetchingAllUsers}
            oldUsersError={this.state.allUsersLoadFailed}
            oldMatchedKeys={this.state.matchedKeys}
            columnNames={this.state.columnNames}
            isUserListUpload
          />
        )}

        <div className="bwai-users-toolbar">
          <div className="bwai-users-toolbar-search">
            <LocalSearchBar
              onSearch={this.handleSearch}
              onClearSearch={this.clearSearch}
              isSearching={isSearching}
              placeholder="Search users..."
              mobilePlaceholder="Search users..."
            />
          </div>

          <div className="bwai-users-toolbar-sort">
            <span className="bwai-users-sort-label">Sort</span>
            <div className="bwai-users-sort-select">
              <Select
                name="sortSelect"
                value={selectedSortOption}
                /* Unfiltered: hiding the current option meant react-select
                   never marked one selected, so no tick could render. */
                options={SORT_OPTIONS}
                onChange={this.handleSortChange}
                /* `clearable`, not `isClearable`: the latter is a react-select
                   v2 prop that v1 ignores, leaving Escape able to clear. */
                clearable={false}
              />
            </div>
          </div>

          {this.props.user.role.toLowerCase().includes('admin') && (
            <React.Fragment>
              <Button
                onClick={() => this.downloadAllUsers()}
                color="primary"
                size="sm"
                className="bwai-btn-secondary"
                disabled={loading}
              >
                <LuDownload size={15} className="mr-2" />
                {loading ? "Getting Data..." : "Download All Users"}
              </Button>

              {this.props.user.role === "Admin" && this.props.user.orgAdmin === true && (
                <Button
                  color="secondary"
                  size="sm"
                  className="bwai-btn-secondary"
                  onClick={() => this.downloadOptOutReport()}
                >
                  See Opt-outs
                </Button>
              )}
            </React.Fragment>
          )}
        </div>

        <div className="active-account-tag bwai-users-legend">
          {/* Wrapped so the row can space-between without the icon parting
              company with its own caption. */}
          <span className="bwai-users-legend-text">
            <LuBadgeCheck color="green" className="mr-1" size={14} />{" "}
            indicates user has logged in and activated account
          </span>

          {usersRemove.length > 0 && (
            <Button
              color="danger"
              className="bwai-users-btn-danger"
              onClick={this.removeMultipleUsers}
            >
              <LuTrash2 size={14} className="mr-2" />
              Remove selected users
            </Button>
          )}
        </div>

        <div className="users-table-frame">
          <div className="users-table-header-wrap">
            <UsersTableHeader
              updateBy={this.updateSortMode}
              role={this.props.user.role}
              columnWidths={appliedColumnWidths}
              onColumnResize={this.handleColumnResize}
              onColumnResizeEnd={this.handleColumnResizeEnd}
            />
          </div>
          <div className="users-table-body">
            {displayUsers.length > 0 ? (
              displayUsers.map((officeMate, index) => (
                <OfficeMate
                  key={officeMate._id}
                  officeMate={officeMate}
                  showUserIdColumn
                  userRole={this.props.user.role}
                  user={this.props.user}
                  onUserRemoved={() =>
                    this.setState({
                      officeMates: this.state.officeMates.filter(
                        (u) => u._id !== officeMate._id
                      ),
                      displayUsers: this.state.displayUsers.filter(
                        (u) => u._id !== officeMate._id
                      ),
                    })
                  }
                  handleEmailChange={this.handleEmailChange}
                  handleMobileNumberChange={this.handleMobileNumberChange}
                  handleEmployeeIdChange={this.handleEmployeeIdChange}
                  onRoleChange={this.handleRoleChange}
                  userSelectedForRemove={this.userSelectedForRemove}
                  removeChecked={usersRemove.includes(officeMate._id)}
                  handleNameChange={this.handleNameChange}
                  rowIndex={index}
                  columnWidths={appliedColumnWidths}
                  {...this.props}
                />
              ))
            ) : (
              <EmptyTable
                title="No results found"
                subtitle="Try rephrasing your search to find users in your enterprise"
              />
            )}
          </div>
          {this.renderPagination()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user.profile,
});

const mapDispatchToProps = dispatch => {
  return {
    updateUserProfile: (userData) => dispatch(actionCreators.updateProfileInfoSuccess(userData)),
    fetchSmsOptOutReport: () => dispatch(actionCreators.fetchSmsOptOutReport()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Loading(withRouter(UsersList), axios));
